type Props = {
  collapsed?: boolean;
};

export default function LeaveIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="30"
        height="22"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(1.5)" }}
        className={collapsed ? "" : "relative left-[6px]"}
      >
        <path
          d="M1 19.1949H17.5M5.80905 19.1953C4.37372 18.5364 3.15763 17.4795 2.30519 16.15C1.45274 14.8205 0.999745 13.2743 1 11.6949V7.19495H17.5M17.5 7.19495V11.6949C17.5003 13.2743 17.0473 14.8205 16.1948 16.15C15.3423 17.4795 14.1262 18.5365 12.6909 19.1953M17.5 7.19495C18.2956 7.19495 19.0587 7.51102 19.6213 8.07363C20.1839 8.63623 20.5 9.3993 20.5 10.1949V10.9449C20.5 11.7406 20.1839 12.5037 19.6213 13.0663C19.0587 13.6289 18.2956 13.9449 17.5 13.9449H17.1833M12.25 1.19495V4.19495M9.25 1.19495V4.19495M6.25 1.19495V4.19495"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
